import { Component } from 'react';
import { FormGroup, Input as BootstrapInput, Label } from 'reactstrap';

import './input-select.css';

class InputSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value || '',
    };
  }

  render() {
    const fieldId = this.props.id ? this.props.id : this.props.name;
    const small = this.props.small;

    return (
      <FormGroup className={small ? 'mx-0 mb-0 mt-2 p-0 small' : 'm-2'}>
        {this.props.label && (
          <Label className="font-weight-bold mb-0" for={fieldId}>
            {this.props.label}
          </Label>
        )}
        <BootstrapInput
          {...this.props}
          value={this.props.value}
          className={small ? 'input-sm' : ''}
          style={small ? { height: 18, fontSize: 11, width: 100 } : {}}
          onChange={(e) => {
            const value = e.target.value;
            this.setState({ value });
            this.props.onChange(value);
          }}
          type="select"
          name={fieldId}
          id={fieldId}
        >
          {this.props.options}
        </BootstrapInput>
      </FormGroup>
    );
  }
}

export default InputSelect;
